<template>
  <div class="page">
    <page-header />
    <div class="page__bd">
      <div class="sidebar">
        <tree-panel :items="treeItems" :selection="article.id" @select="showDoc" />
      </div>
      <div class="doc__wrp" @click="onDocClick($event)">
        <div v-html="article.contentHtml"></div>
      </div>
    </div>
    <image-viewer ref="imageViewer" />
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import TreePanel from "@/components/TreePanel.vue";
import ImageViewer from "@/components/ImageViewer.vue";

export default {
  components: {
    PageHeader,
    TreePanel,
    ImageViewer
  },
  props: {
    projectCode: String,
    itemCode: String
  },
  data() {
    return {
      project: {
        items: [],
        homepage: null
      },
      article: {
        contentHtml: null
      },
      treeItems: []
    };
  },
  created() {
    var me = this;
    if (me.projectCode) {
      me.getProjectDetail(me.projectCode);
      if (me.itemCode) {
        me.getArticle(me.projectCode, me.itemCode);
      }
    }
  },
  watch: {
    projectCode(val) {
      this.getProjectDetail(val);
    },
    itemCode(val) {
      if (val) {
        this.getArticle(this.projectCode, val);
      }
    }
  },
  methods: {
    showDoc(node) {
      if (node.itemCode != this.itemCode) {
        this.$router.push("/doc/" + node.projectCode + "/" + node.itemCode);
      }
    },
    getProjectDetail(code) {
      var me = this;
      me.$ajax({
        url: "/api/help/project/read",
        params: {
          code
        }
      }).then(function(res) {
        if (res.success) {
          me.project = res.data;
          if (!me.itemCode && me.project.homepage) {
            // 跳转项目首页
            me.$router.push("/doc/" + code + "/" + me.project.homepage);
          }
          me.treeItems = (res.data.items || []).map(item => {
            return me.convertItemToTreeNode(item);
          });
        }
      });
    },
    getArticle(projectCode, itemCode) {
      var me = this;
      me.$ajax({
        url: "/api/help/article/read",
        params: {
          projectCode,
          itemCode
        }
      }).then(function(res) {
        if (res.success) {
          me.article = res.data || {};
          me.$nextTick(function() {
            me.resizeImg();
          });
        }
      });
    },
    convertItemToTreeNode(item) {
      var me = this,
        node = {
          id: item.id,
          text: item.name,
          projectCode: me.projectCode,
          itemCode: item.code
        };
      if (!item.article) {
        node.expand = false;
        if (item.children) {
          node.children = item.children.map(i => {
            var c = me.convertItemToTreeNode(i);
            if (c.expand || i.code == me.itemCode) {
              node.expand = true;
            }
            return c;
          });
        }
      } else {
        node.leaf = true;
      }
      return node;
    },
    resizeImg() {
      // 适应文档最大宽度，等比例缩放图片
      var nodes = document.querySelectorAll(".doc__wrp img"),
        maxWidth = 880;
      nodes.forEach(node => {
        if (node.width > maxWidth) {
          node.style.zoom = maxWidth / node.width;
        } else {
          node.onload = function() {
            if (node.width > maxWidth) {
              node.style.zoom = maxWidth / node.width;
            }
          };
        }
      });
    },
    onDocClick(e) {
      var me = this,
        target = e.target;
      if (target.nodeName == "IMG") {
        me.$refs.imageViewer.setImage(target.src);
        e.preventDefault();
      }
    }
  }
};
</script>

<style scoped>
.sidebar {
  top: 65px;
}
</style>